exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.required-feedback[data-v-539c9400]{width:100%;margin-top:0.25rem;font-size:0.875em;color:#dc3545\n}\n", ""]);

// exports
